export const en = {
    error_title: 'Unfortunately the Yandex Business Trips service is not yet available',
    error_description: 'We are already aware of the problem and will fix everything soon',
    no_access_title: 'You currently do not have access to the service',
    no_access_description: "Contact your company's coordinator",
};
